export function toTop() {
    const $window = $(window);
    let toTopButton = $(".to-top");
    $window.on("scroll load", function () {
        if ($window.scrollTop() > $window.innerHeight() / 3) {
            toTopButton.addClass("show");
        } else {
            toTopButton.removeClass("show");
        }
    });

    toTopButton.on("click", function (event) {
        event.preventDefault();
        $('body,html').stop().animate({scrollTop: 0}, 400);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/to-top.js